import styled from 'styled-components';

import {PrussianBlueBg as prussian} from 'shared/styles';

export const PrussianBlueBg = styled(prussian)`
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const Cont = styled.div`
    position: relative;
    width: 100px;
`;